module.exports = __webpack_public_path__ + "static/media/8-3.6ae39487.mp3";